import { GET_MOUVEMENTS_CLAL, ADD_MOUVEMENT_CLAL, UPDATE_MOUVEMENT_CLAL, DELETE_MOUVEMENT_CLAL } from '../actions/action-types';

const initialState = { liste: [], loadedAt: null };

export default function mouvementsClalReducer(state = initialState, action) {
  switch(action.type) {
    case GET_MOUVEMENTS_CLAL:
      return { ...state, liste: action.payload || [], loadedAt: Date.now() };
    case ADD_MOUVEMENT_CLAL:
      return { ...state, liste: [ ...(state.liste||[]), action.payload ] };
    case UPDATE_MOUVEMENT_CLAL:
      return { ...state, liste: state.liste.map(m => m.id === action.payload.id ? { ...m, ...action.payload } : m) };
    case DELETE_MOUVEMENT_CLAL:
      return { ...state, liste: state.liste.filter(m => m.id !== action.payload) };
    default:
      return state;
  }
}
